import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IProfileRepository } from '../../repositories/interfaces/iProfileRepository';
import { IProfileData } from '@intigral/types';

export interface IDeleteProfileUseCase {
    execute(
        apiKey: string,
        guid: string,
        userPassword: string,
        token: string,
        authSign: string,
        identityToken: string,
        currentProfile: IProfileData,
        csrfToken?: { [key: string]: string }
    ): Promise<any>;
}

export class DeleteProfileUseCase implements IDeleteProfileUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get profileRepository(): IProfileRepository {
        return container.resolve<IProfileRepository>(DI.REPOSITORIES.IProfileRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        apiKey: string,
        guid: string,
        userPassword: string,
        token: string,
        authSign: string,
        identityToken: string,
        currentProfile: IProfileData,
        csrfToken: { [key: string]: string }
    ): Promise<any> {
        const profile = await this.profileRepository.deleteProfile(
            apiKey,
            guid,
            userPassword,
            token,
            authSign,
            identityToken,
            currentProfile,
            csrfToken
        );
        return profile.data;
    }
}
